import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '@evi/shared';
import { api } from '@/lib/api';
import type { TodayInbox } from '@/lib/todayInbox';

/**
 * The Today inbox (GET /admin/today): the Today page's rows and the Today leaf's badge share one query. Asked only where
 * the menu has a Today leaf; refreshed every minute, as EVI Queues is.
 */
export function useTodayInbox(enabled: boolean) {
  return useQuery({
    queryKey: ['admin-today'], enabled, refetchInterval: 60_000, retry: false, staleTime: 15_000,
    queryFn: () => api.get('admin/today', { retry: 0 }).json<ApiResponse<TodayInbox>>().then(r => r.data!),
  });
}
